import { PullToRefresh as AntdMobilePullToRefresh } from "antd-mobile";
import { BasePullToRefreshProps } from "./PullToRefresh.types";
import { LoadingSpinner } from "../../LoadingSpinner";
import { isMousePrimaryDevice } from "../utils";
import "./PullToRefresh.scss";

// 自定义渲染函数
const renderStatusContent = () => {
  return <LoadingSpinner size={30} />;
};

export const PullToRefresh: React.FC<BasePullToRefreshProps> = ({
  children,
  onRefresh,
  canRefresh = true,
  disabled = false,
  threshold = 30,
  headHeight = 30,
  className = "",
  testId,
}) => {
  // 桌面（鼠标为主指针）不装下拉刷新：底层 use-gesture 的 drag 对鼠标同样生效，
  // 在页顶用鼠标往下拖过 threshold(30px) 就会 onRefresh → 整页 reload。
  // 实测：首页 scrollTop=0 时鼠标下拖一次 = 刷一次，连续拖就是「一直重复刷新」。
  // 下拉刷新本身是触摸手势，桌面用户要刷新按 F5，这里直接不接。
  if (!canRefresh || isMousePrimaryDevice()) {
    return <>{children}</>;
  }
  const pullToRefreshClass = [
    "pull-to-refresh",
    disabled && "pull-to-refresh--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={pullToRefreshClass} data-testid={testId}>
      <AntdMobilePullToRefresh
        onRefresh={onRefresh}
        disabled={disabled}
        threshold={threshold}
        headHeight={headHeight}
        renderText={renderStatusContent}
      >
        {children}
      </AntdMobilePullToRefresh>
    </div>
  );
};

export default PullToRefresh;
